import { useTranslation } from "react-i18next";
import type { UserManagementFiltersModel } from "~/hooks/useUserManagementFilters";
import { ActiveFilterChips, type ActiveFilterChip } from "./ActiveFilterChips";

interface UserManagementActiveFilterChipsProps {
  filters: UserManagementFiltersModel;
}

export const UserManagementActiveFilterChips = ({
  filters,
}: UserManagementActiveFilterChipsProps) => {
  const { t } = useTranslation();
  const selectedStatusValues = new Set<string>(filters.selectedStatuses);
  const selectedStatusLabels = filters.statusOptions
    .filter((option) => selectedStatusValues.has(option.value))
    .map((option) => option.label)
    .join(", ");
  const activeFilterItems: ActiveFilterChip[] =
    filters.selectedStatuses.length > 0
      ? [
          {
            key: "status",
            label: t(($) => $.commons.document.status),
            comparatorLabel: t(($) => $.library.filters.includes),
            value: selectedStatusLabels,
            onRemove: filters.clearStatusFilter,
          },
        ]
      : [];

  return <ActiveFilterChips items={activeFilterItems} />;
};
